import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
} from '../../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'

import { NavBar } from '../../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { activatePolicy, clearPolicies, deletePolicy, getPolicies } from 'features/attendance/attendanceSlice'
import { NoData } from 'components/NoData'
import { useNavigate } from 'react-router-dom'
import { Options } from 'components/Options/Options'
import { setConfirmModal } from 'features/global/globalSlice'
import { ModalTypes } from 'types/global.interface'

export const AttendancePolicies: React.FC = () => {
    const { policies } = useSelector((store: RootState) => store.attendance)
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const navigate = useNavigate()

    useQueryPagination({ fetchFunctions: [getPolicies], cleanUpFunctions: [clearPolicies], params })

    const handleRemove = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deletePolicy(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                },
                word: 'delete policy',
            }),
        )
    }

    const handleActivate = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(activatePolicy(id))
                },
                setParams: {
                    type: ModalTypes.BeforeSabe,
                    f: setParams,
                },
                word: 'activate this policy',
            }),
        )
    }

    return (
        <>
            <NavBar defaultValue={params.q} input placeholder='Search policies...' setParams={setParams} limit={30} />
            <PageWrapper>
                <Flex between center mb='16' >
                    <H1WithBack arrow title='Policies' />
                    <Button orange onClick={() => navigate('add')}>
                        Add Policy
                    </Button>
                </Flex>
                {!policies?.data.length ? (
                    <NoData />
                ) : (
                    <Table>
                        <Th>
                            <Td w='20%' noTooltip text='NAME' />
                            <Td w='20%' noTooltip text='ACTIVE' />
                            <Td w='65%' noTooltip text='CREATED AT' />
                            <Td w='5%' />
                        </Th>
                        {policies.data.map((item) => {
                            return (
                                <Tr key={item.id}>
                                    <Td w='20%' noTooltip text={item.name} />
                                    <Td w='20%' noTooltip text={item.isActive ? 'Yes' : 'No'} />
                                    <Td w='65%' noTooltip text={formatDateForDisplay(item.createdAt)} />
                                    <Td w='5%' options>
                                        <Options openModal={handleActivate} handleRemove={handleRemove} item={item} title='Policies' />
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Table>
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(policies.totalCount)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
